import React from "react";
import {Outlet} from "react-router-dom";
import {ProjectProvider} from "../context/ProjectContext";
import {PresetsProvider} from "../context/presetsContext";


const ProjectsLoaderWrapper = () => {
    return (
        <ProjectProvider>
            <PresetsProvider>
                <Outlet/>
            </PresetsProvider>
        </ProjectProvider>
    );
}

export default ProjectsLoaderWrapper;